module.exports = __webpack_public_path__ + "img/img-9.434fdcc0.jpg";